import { UserSectorContext } from "@/core/providers/UserSectorProvider/context";
import { useContext } from "react";

export const useUserSector = () => {
  const context = useContext(UserSectorContext);
  if (!context) {
    throw new Error("useUserSector must be used within a UserSectorProvider");
  }
  return context;
};
